<template>
  <div class="info-box">
    <div class="flex-1 overflow-y-auto pr-2" id="printDom">
      <ul class="font-bold text-center text-gray-900 text-base">
        {{
          state.model?.meeting?.bill_title
        }}会议项目报账单
      </ul>
      <ul class="mt-5">
        尊敬的客户，{{
          state.model?.meeting?.bill_title
        }}非常荣幸协办本次
        <strong>“{{ state.model?.meeting?.name }}”</strong>
        会议；本次会议在贵司的大力支持下，已圆满结束。特将本次会议报账明细呈送给您审阅。如您对本账单有任何疑问，可随时拨打公司电话{{
          state.model?.meeting?.phone
        }}，或联系会务项目经理{{
          state.model?.meeting?.belonger_name +
          state.model?.meeting?.belonger_phone
        }}！
      </ul>
      <c_cell title="会议名称" class="mt-5">
        <template #default>
          <strong>{{ state.model?.meeting?.name }}</strong>
        </template>
      </c_cell>
      <ul class="grid grid-cols-2 mt-3">
        <c_cell title="会议编号" :value="state.model?.meeting?.number" />
        <c_cell
          title="会议时间"
          :value="
            state.model?.meeting?.start_date +
            ' ~ ' +
            state.model?.meeting?.end_date
          "
        />
      </ul>
      <!-- <ul class="flex gap-x-5 mt-3">
        <c_cell
          title="会议负责人"
          :value="state.model?.meeting?.belonger_name"
        />
        <c_cell title="设计师" :value="state.model?.meeting?.start_time" />
        <c_cell title="车队调度员" :value="state.model?.meeting?.start_time" />
        <c_cell title="物料采购员" :value="state.model?.meeting?.start_time" />
      </ul> -->
      <!-- <c_cell
        title="摘要"
        class="!items-start mt-3 !w-full !grid"
        style="grid-template-columns: auto 1fr"
      >
        <template #default>
          <text v-if="props.search">{{ state.model.intro }}</text>
          <el-input
            v-else
            v-model="state.intro"
            type="textarea"
            class="w-full"
          />
        </template>
      </c_cell> -->
      <c_cell title="会议地点" class="mt-3 items-baseline">
        <template #default>
          <text>{{
            state.model?.hotelList?.map((m) => m.name).join("、") || "-"
          }}</text>
        </template>
      </c_cell>
      <ul class="flex items-center mt-5 text-xs">
        报账金额合计：<c_money
          :value="state.model?.item_amount"
          :key="state.model?.item_amount"
          :prefix="false"
          :size="16"
        />
        <span class="w-5"></span>
        服务费：<c_money
          :value="state.model?.service_fee_amount"
          :key="state.model?.service_fee_amount"
          :prefix="false"
          :size="16"
        />
        （按报账金额合计{{
          $formatDecimal(state.model?.service_fee_rate)
        }}%收取）
        <span class="w-5"></span>
        免税报账金额合计：<c_money
          :value="state.model?.free_tax_item_amount"
          :key="state.model?.free_tax_item_amount"
          :prefix="false"
          :size="16"
        />
        <span class="w-5"></span>
        应税报账金额合计：<c_money
          :value="state.model?.tax_item_amount"
          :key="state.model?.tax_item_amount"
          :prefix="false"
          :size="16"
        />
        <span class="w-5"></span>
        含服务费后税费合计：<c_money
          :value="state.model?.tax_fee_amount"
          :key="state.model?.tax_fee_amount"
          :prefix="false"
          :size="16"
        />
        （税率{{
          $formatDecimal(state.model?.tax_fee_rate)
        }}%）
        <span class="w-5"></span>
        报账总金额：<c_money
          :value="state.model?.amount"
          :key="state.model?.amount"
          bold
          :prefix="false"
          :size="16"
        />
        <span class="w-5"></span>
        明细如下：
      </ul>
      <el-table
        :data="state.model?.meetingPurchaseItemList"
        v-loading="!Array.isArray(state.model?.meetingPurchaseItemList)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        class="flex-1 mt-1"
        :showOverflowTooltip="false"
      >
        <el-table-column
          label="类型"
          prop="d_cost_type_name"
          :formatter="$tab_TextFormat"
          align="center"
          :width="140"
        />
        <el-table-column
          label="所属会场"
          prop="meetingPlace.name"
          :formatter="$tab_TextFormat"
          align="center"
          :width="200"
        />
        <el-table-column
          label="采购项目"
          prop="name"
          :formatter="$tab_TextFormat"
          align="center"
          :width="200"
        />
        <el-table-column
          label="规格"
          prop="specification"
          :formatter="$tab_TextFormat"
          align="center"
          :width="200"
        />
        <el-table-column
          label="报账单价(元)"
          prop="bill_price"
          :formatter="$tab_TextFormat"
          align="center"
          :width="120"
        />
        <el-table-column
          label="报账数量"
          prop="bill_count"
          :formatter="$tab_TextFormat"
          align="center"
          :width="100"
        />
        <el-table-column label="天数" align="center" :width="100">
          <template #default="{ row }">
            <text>
              {{ formatMaxTwoDecimals(row.bill_day_count || "1") }}
            </text>
          </template>
        </el-table-column>
        <el-table-column
          label="报账金额"
          prop="bill_amount"
          :formatter="$tab_TextFormat"
          align="center"
          :width="140"
        />
        <el-table-column
          label="备注"
          prop="bill_remark"
          :formatter="$tab_TextFormat"
          align="center"
        />
      </el-table>
    </div>
    <div class="submit-box px-2.5 flex items-center justify-end">
      <template v-if="state.model?.print_count > 0">
        <c_cell title="打印次数">{{ state.model?.print_count }}次</c_cell>
        <c_cell title="最后打印时间" class="mr-10">
          {{ state.model?.print_time }}
        </c_cell>
      </template>
      <template v-if="props.search">
        <el-button type="primary" @click="onExport"> 导出报账单 </el-button>
        <el-button
          plain
          :icon="Printer"
          v-print="printObj"
          v-if="
            state.model?.meeting?.belonger_id == $store.state?.loginUser?.id
          "
          @click="onPrint"
        >
          打印报账单
        </el-button>
      </template>
      <el-button v-else type="primary" size="large" @click="onSubmit">
        确认生成
      </el-button>
    </div>
  </div>
  <el-dialog
    v-model="state.showBuild"
    :title="state.build_title"
    class="c-el-dialog"
    :before-close="
      () => {
        state.showBuild = false;
      }
    "
    width="80%"
    style="height: 80%; max-height: 80%"
    append-to="#home_box"
    modal
  >
    <c_print
      :meeting_id="props.meeting_id"
      :meeting_place_id="state.select_place?.id"
      @close="
        () => {
          onLoad();
        }
      "
    />
  </el-dialog>
</template>

<script>
import { onMounted, reactive } from "vue";
import {
  meeting_bill_record_getAddData,
  meeting_bill_record_add,
  meeting_bill_record_detail,
  meeting_bill_record_export,
  meeting_bill_record_recordPrint,
} from "@/http/meeting";
import { ElMessage, ElMessageBox } from "element-plus";
import { formatMaxTwoDecimals } from "@/utils/funcs";

export default {
  props: {
    meeting_id: Number,
    meeting_place_id: Number,
    search: Boolean,
  },
  setup(props, { emit }) {
    const printObj = {
      id: "printDom",
      beforeOpenCallback() {},
    };
    const state = reactive({
      model: {},
    });
    onMounted(() => {
      if (props.search) {
        meeting_bill_record_detail({
          meeting_id: props.meeting_id,
          meeting_place_id: props.meeting_place_id,
        }).then((res) => {
          if (res.status == 200) {
            state.model = res.data?.data || {};
          }
        });
      } else {
        meeting_bill_record_getAddData({
          meeting_id: props.meeting_id,
          meeting_place_id: props.meeting_place_id,
        }).then((res) => {
          if (res.status == 200) {
            state.model = res.data?.data || {};
          }
        });
      }
    });

    const onSubmit = () => {
      ElMessageBox.confirm(`您确定生成报账单吗`, "生成报账单", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        dangerouslyUseHTMLString: true,
        customClass: "c-delete-dialog",
        cancelButtonClass: "is-plain",
      }).then(() => {
        meeting_bill_record_add({
          meeting_id: props.meeting_id,
          meeting_place_id: props.meeting_place_id,
          intro: state.intro,
        }).then((res) => {
          if (res.status == 200) {
            ElMessage.success(res.data.msg);
            emit("close");
          } else {
            ElMessage.error(res.data.msg);
          }
        });
      });
    };

    const onExport = () => {
      meeting_bill_record_export({
        id: state.model?.id,
      })
        .then((res) => {
          let fileName = decodeURI(
            res.headers["content-disposition"].split("=")[1],
          );

          //通过后台返回 的word文件流设置文件名并下载
          var blob = new Blob([res.data], {
            type: res.data.type,
          });
          var downloadElement = document.createElement("a");
          var href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = fileName; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
        })
        .catch((err) => {
          const fileReader = new FileReader();
          fileReader.readAsText(
            new Blob([err.data], { type: "application/octet-stream" }),
            "utf-8",
          );
          fileReader.onload = () => {
            const msg = JSON.parse(fileReader.result);
            ElMessage.error(msg?.msg);
          };
        });
    };

    const onPrint = () => {
      console.log(12312321);

      meeting_bill_record_recordPrint(state.model?.id);
    };

    return {
      state,
      props,
      onSubmit,
      printObj,
      formatMaxTwoDecimals,
      onExport,
      onPrint,
    };
  },
};
</script>

<style lang="scss" scoped>
@media print {
  @page {
    size: auto;
    margin: 20px;
    page-break-before: always;
  }
  body * {
    visibility: hidden;
  }
  #printDom,
  #printDom * {
    visibility: visible;
  }
  #printDom {
    position: absolute;
    left: 0;
    top: 0;
  }

  #printDom::before {
    content: attr(data-title);
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 10px;
    display: block;
    text-align: center;
  }
}
</style>
